import React, { useEffect, useState, useRef } from "react";
import Search from "../components/ProductCondition/Search";
import Header from "../components/ProductCondition/Header";
import QualityInput from "../components/ProductCondition/QualityInput";
import QualityList from "../components/ProductCondition/QualityList";
import Average from "../components/ProductCondition/Average";
import config from "../config";
import { initialInputData } from "../util/init";
import { convertDateToyyyymmdd, yyyymmddToDate } from "../util/date";
import axios from "axios";
import DelModal from "../components/ProductCondition/DelModal";
import { shncodToRcodex } from "../util/mapper";

const ProductCondition = () => {
    const [resbody, setResbody] = useState();
    const [resAvgBody, setResAvgBody] = useState();
    const [inputData, setInputData] = useState(initialInputData);
    const [selectedData, setSelectedData] = useState(null);
    const [stagingStatus, setStagingStatus] = useState();
    const [isDelModal, setIsDelModal] = useState(false);
    const cellRefs = useRef([]);
    const [searchRequestData, setSearchRequestData] = useState({
        HOGIXX: "ALL",
        STDATE: new Date(),
        ENDATE: new Date(),
        PKCDXX: null,
        BSSWGH: null,
    });
    const handleSearch = async () => {
        try {
            const resbody = await axios({
                url: `${config.apiUrl}/drydampExamSel.do`,
                method: "POST",
                data: {
                    hogixx: searchRequestData.HOGIXX,
                    stdate: convertDateToyyyymmdd(searchRequestData.STDATE),
                    endate: convertDateToyyyymmdd(searchRequestData.ENDATE),
                    pkcdxx: searchRequestData.PKCDXX,
                    bsswgh: searchRequestData.BSSWGH,
                },
            });
            const resAvgBody = await axios({
                url: `${config.apiUrl}/jospJPH.do`,
                method: "POST",
                data: {
                    stdate: convertDateToyyyymmdd(searchRequestData.STDATE),
                    endate: convertDateToyyyymmdd(searchRequestData.ENDATE),
                    pkcdxx: searchRequestData.PKCDXX ?? "",
                    bsswgh: searchRequestData.BSSWGH ?? "",
                    hogixx:
                        searchRequestData.HOGIXX === "ALL"
                            ? ""
                            : searchRequestData.HOGIXX,
                },
            });
            resbody.data.resultData = resbody.data.resultData.sort(
                (a, b) =>
                    a.PPDATE - b.PPDATE ||
                    a.PPTIME - b.PPTIME ||
                    a.HOGIXX - b.HOGIXX ||
                    shncodToRcodex[a.PKCDXX] < shncodToRcodex[b.PKCDXX] ||
                    a.BSSWGH - b.BSSWGH
            );
            setResbody(resbody.data);
            setResAvgBody(resAvgBody.data);
            console.log(resbody);
        } catch (err) {
            console.log(err);
        }
    };
    const handelDelete = async () => {
        try {
            const res = await axios({
                url: `${config.apiUrl}/drydampExamDel.do`,
                method: "post",
                data: {
                    hogixx: inputData.HOGIXX,
                    ppdate: inputData.PPDATE,
                    pptime: inputData.PPTIME,
                },
            });
            delModalClose();
            handleSearch();
        } catch (e) {
            console.log(e);
        }
    };

    const handleRefresh = () => {
        setInputData(initialInputData);
        setStagingStatus(null);
    };
    const handleSave = async () => {
        let res = {};
        try {
            if (inputData.PPTIME === null) {
                cellRefs.current[1].focus();
                throw new Error("PPTIME 을 입력해주세요.");
            }
            res = await axios({
                url: `${config.apiUrl}/drydampExamReg.do`,
                method: "POST",
                data: {
                    ppdate: inputData.PPDATE,
                    pptime: inputData.PPTIME,
                    pkcdxx: inputData.PKCDXX,
                    bsswgh: inputData.BSSWGH,
                    hogixx: inputData.HOGIXX,
                    speedx: inputData.SPEEDX,
                    sbsswg: inputData.SBSSWG,
                    waterx: inputData.WATERX,
                    thickx: inputData.THICKX,
                    mildox: (inputData.SBSSWG / inputData.THICKX).toFixed(3),
                    mdabga: inputData.MDABGA,
                    cdabga: inputData.CDABGA,
                    cdindx: (
                        (inputData.CDABGA / inputData.SBSSWG) *
                        100
                    ).toFixed(2),
                    mdcdxx: inputData.MDCDXX,
                    pagang: inputData.PAGANG,
                    paindx: (
                        (inputData.PAGANG / inputData.SBSSWG) *
                        100
                    ).toFixed(2),
                    colorl: inputData.COLORL,
                    colora: inputData.COLORA,
                    colorb: inputData.COLORB,
                    cobbsi: inputData.COBBSI,
                    cobbte: inputData.COBBTE,
                    cobbde: inputData.COBBDE,
                },
            });
        } catch (e) {
            console.log(e);
        }
        searchAfterSave();
    };
    const searchAfterSave = async () => {
        // save 후 검색 값 변경.
        let search = {
            ...searchRequestData,
        };

        // 조건 : 입력된 날짜가 현재 날짜보다 전이면, 현재 날짜를 입력 날짜로 변경.
        if (
            parseInt(inputData.PPDATE) <
            parseInt(convertDateToyyyymmdd(searchRequestData.STDATE))
        ) {
            search = {
                ...search,
                HOGIXX: inputData.HOGIXX,
                STDATE: yyyymmddToDate(inputData.PPDATE),
            };
        } else {
            search = {
                ...search,
                HOGIXX: inputData.HOGIXX,
            };
        }
        setSearchRequestData(search);

        // 변경 된 값으로 search api 요청
        const resbody = await axios({
            url: `${config.apiUrl}/drydampExamSel.do`,
            method: "POST",
            data: {
                hogixx: search.HOGIXX,
                stdate: convertDateToyyyymmdd(search.STDATE),
                endate: convertDateToyyyymmdd(search.ENDATE),
                pkcdxx: search.PKCDXX,
                bsswgh: search.BSSWGH,
            },
        });
        setResbody(resbody.data);
    };
    const delModalOpen = () => {
        if (selectedData === undefined || selectedData === null || isDelModal) {
            return;
        }
        setIsDelModal(true);
    };
    const delModalClose = () => {
        setIsDelModal(false);
    };

    const handleKeydownEnter = (e, index) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            if (index < cellRefs.current.length - 1) {
                cellRefs.current[index + 1].focus();
            } else {
                cellRefs.current[index].blur();
                handleSave();
            }
        }
    };
    // keydown event
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "F8" || e.keyCode === 119) {
                e.preventDefault();
                delModalOpen();
            }
            if (e.key === "F9" || e.keyCode === 120) {
                e.preventDefault();
                handleSave();
                return;
            }
            if (e.key === "F11" || e.keyCode === 122) {
                e.preventDefault();
                handleRefresh();
                return;
            }
            if (e.key === "F7" || e.keyCode === 118) {
                e.preventDefault();
                handleSearch();
                return;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [inputData, isDelModal, selectedData, searchRequestData]);
    return (
        <div className="bg-blue-200 min-h-screen flex-col flex">
            <Header
                enter={handleKeydownEnter}
                del={delModalOpen}
                refresh={handleRefresh}
                save={handleSave}
                title={"조습 품질 실험 결과"}
            />
            {isDelModal && (
                <DelModal
                    isDelModal={isDelModal}
                    handelDelete={handelDelete}
                    delModalOpen={delModalOpen}
                    delModalClose={delModalClose}
                />
            )}
            <Search
                handleSearch={handleSearch}
                searchRequestData={searchRequestData}
                setSearchRequestData={setSearchRequestData}
                setResbody={setResbody}
            />
            <QualityInput
                cellRefs={cellRefs}
                inputData={inputData}
                setInputData={setInputData}
                selectedData={selectedData}
                enter={handleKeydownEnter}
            />
            <QualityList
                setInputData={setInputData}
                stagingStatus={stagingStatus}
                setStagingStatus={setStagingStatus}
                resbody={resbody}
                setSelectedData={setSelectedData}
            />
            <Average resbody={resAvgBody} />
        </div>
    );
};

export default ProductCondition;
